import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { isValidEmail } from '@/lib/utils';

import { authLayoutRoute } from '../layouts/auth-layout-route';

export const loginRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/login',
  component: lazyRouteComponent(() => import('@/pages/auth/login-page')),
});

export const registerRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/register',
  component: lazyRouteComponent(() => import('@/pages/auth/register-page')),
});

export const resendEmailRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/resend-email/$email',
  beforeLoad: async ({ params }) => {
    const { email } = params;
    const validEmail = isValidEmail(email);

    if (!validEmail) {
      // TODO: redirect to not found page
      throw redirect({ to: '/auth/login' });
    }
  },
  component: lazyRouteComponent(() => import('@/pages/auth/resend-email-page')),
});

export const verificationEmailRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/verification-email/$token',
  component: lazyRouteComponent(() => import('@/pages/auth/verification-email-page')),
});

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/forgot-password',
  component: lazyRouteComponent(() => import('@/pages/auth/forgot-password-page')),
});

export const resetPasswordRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/reset-password/$token',
  component: lazyRouteComponent(() => import('@/pages/auth/reset-password-page')),
});

export const registerMemberRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/register-member/$email/$token',
  beforeLoad: async ({ params }) => {
    const { email, token } = params;
    const validEmail = isValidEmail(email);

    if (!validEmail && !token) {
      throw redirect({ to: '/auth/login' });
    }
  },
  component: lazyRouteComponent(() => import('@/pages/auth/register-member-page')),
});
